import React, { useState } from "react";
import axios from "axios";
import { HelpCircle, X, Loader2 } from "lucide-react";
import LessonVideo from "./LessonVideo";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Кнопка «Как это работает»: открывает видеоурок Академии прямо на том экране,
 * где менеджер застрял. Урок ищем по слагу, блокировка курса не применяется —
 * это справка.
 */
export const HelpVideoButton = ({ slug, label = "Как это работает",
                                  testId = "help-video-btn", compact = false }) => {
  const [open, setOpen] = useState(false);
  const [lesson, setLesson] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    setOpen(true); setError("");
    try {
      const r = await axios.get(`${API}/academy/lessons/by-slug/${slug}`,
        { withCredentials: true });
      setLesson(r.data);
    } catch (e) {
      setError(e.response?.data?.detail || "Видеоурок не найден");
    }
  };

  return (
    <>
      <button data-testid={testId} onClick={load} title={label}
        style={{ display: "inline-flex", alignItems: "center", gap: 5,
                  background: "transparent", border: "1px solid #e5e7eb",
                  borderRadius: 999, padding: compact ? "4px 8px" : "6px 12px",
                  cursor: "pointer", fontFamily: "Manrope", fontSize: 12,
                  color: "#6b7280" }}>
        <HelpCircle size={compact ? 13 : 14} />
        {!compact && label}
      </button>

      {open && (
        <div data-testid="help-video-modal" onClick={() => setOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(10,10,10,0.72)",
                    zIndex: 1000, display: "flex", alignItems: "center",
                    justifyContent: "center", padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ background: "white", borderRadius: 12, maxWidth: 820,
                      width: "100%", maxHeight: "92vh", overflowY: "auto",
                      padding: 18 }}>
            <div style={{ display: "flex", alignItems: "center",
                           justifyContent: "space-between", gap: 10, marginBottom: 12 }}>
              <div style={{ fontFamily: "Cormorant Garamond, serif", fontSize: 21 }}>
                {lesson?.title || "Видеоурок"}
              </div>
              <button data-testid="help-video-close" onClick={() => setOpen(false)}
                style={{ background: "transparent", border: "none", cursor: "pointer",
                          color: "#6b7280" }}>
                <X size={20} />
              </button>
            </div>
            {error && (
              <div style={{ fontFamily: "Manrope", fontSize: 13, color: "#b91c1c" }}>
                {error}
              </div>
            )}
            {!error && !lesson && (
              <div style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>
                <Loader2 size={22} className="animate-spin" style={{ display: "inline" }} />
              </div>
            )}
            {lesson && (lesson.video_url ? (
              <LessonVideo lessonId={lesson.lesson_id} videoUrl={lesson.video_url}
                poster={lesson.video_poster}
                requiredPercent={lesson.video_required_percent} />
            ) : (
              <div style={{ fontFamily: "Manrope", fontSize: 13, color: "#6b7280" }}>
                Видео пока не загружено. Текстовая инструкция — в Академии,
                модуль «Инструменты: приложение Angiolini».
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default HelpVideoButton;
